import { render } from "./layout2.vue?vue&type=template&id=7a87ebcb"
import script from "./layout2.vue?vue&type=script&lang=js"
export * from "./layout2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__